import { useCallback } from 'react';

import { CareerQuizAnswerInput, useGradeCareerQuizMutation } from 'core/graphql';

import { ICareerQuizResult, transformCareerQuizResult } from './transform';

/**
 * Grades a career-lesson self-check quiz (spec 0020 Фаза C).
 *
 * `answers` is one entry per question (`{ questionId, selectedIndexes }`);
 * scoring is exact-set match on the server. The normalized result finally
 * carries `correctIndexes` (hidden until submit) so the block can show
 * per-question ✓/✗ and highlight the right options. Re-submitting simply
 * re-grades — the «Пройти заново» flow resets local selections and calls again.
 *
 * A transport failure propagates as a thrown ApolloError; the quiz block catches
 * it and shows a retry message. A graded-but-`success:false` payload comes back
 * as a result with `errorCode`/`errorMessage` set (e.g. lesson locked).
 */
export const useSubmitCareerQuiz = () => {
  const [mutate, { loading }] = useGradeCareerQuizMutation();

  const submitQuiz = useCallback(
    async (
      lessonId: string,
      answers: CareerQuizAnswerInput[],
    ): Promise<ICareerQuizResult | null> => {
      const { data } = await mutate({ variables: { lessonId, answers } });
      return transformCareerQuizResult(data);
    },
    [mutate],
  );

  return { submitQuiz, loading };
};
